<div
  #menuCards
  class="menu-cards"
  [ngClass]="type()">
  @for (menuItem of activeMenuItems; track menuItem) {
    <coin-a-app-card
      permissionAccess
      [allowedResources]="menuItem?.resources"
      [allowedActions]="menuItem?.actions"
      [menuItem]="menuItem"
      [type]="type()"
      [translationPrefix]="translationPrefix()"
      (openClicked)="openClicked.emit($event)"></coin-a-app-card>
  }
</div>
